import './otherChannelNode.scss';

const OtherChannelNodeTemplate = () => {
	/* html */
	const html = `
    <div class="engt-component" id="engtChatContent">
        <node></node>
    </div>
    `;

	return html;
};

export default OtherChannelNodeTemplate;
